import { ShieldX } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

export default function AccessDenied({ message = "You do not have permission to access this page." }) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] animate-fade-in" data-testid="access-denied">
      <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mb-6">
        <ShieldX className="w-10 h-10 text-red-500" />
      </div>
      <h1 className="font-heading text-2xl font-semibold text-slate-900 mb-2">
        Access Denied
      </h1>
      <p className="text-slate-500 font-body text-center max-w-md mb-6">
        {message}
      </p>
      <Button 
        onClick={() => navigate('/dashboard')} 
        className="btn-primary"
        data-testid="go-to-dashboard"
      >
        Go to Dashboard
      </Button>
    </div>
  );
}
